import { UserFindDto, type UserFindInterface } from '@zaoblako/shared/modules/security/dtos/user/user-find.dto';
import { FileFindDto, type FileFindInterface } from '@zaoblako/shared/modules/storage/dtos/file/file-find.dto';
import { DocumentFileTemplateTypeEnum } from '@zaoblako/shared/modules/catalog/enums/document-file-template-type.enum';
import { SerdeDtoClass } from '@zaoblako/shared/modules/serde/classes/serde-dto.class';
import { CatalogDtosKeysEnum } from '@zaoblako/shared/modules/catalog/enums/catalog-dtos-keys.enum';

import * as yup from 'yup';

/** Document file template response body - DTO signature */
export interface DocumentFileTemplateFindInterface {
  /** Unique identifier. Cannot be changed. */
  id: number;
  /** Creation date and time */
  created: Date;
  /** Last update date and time */
  updated: Date;
  /** Soft deletion update date and time. The order will be permanently deleted six months after this date. */
  deleted?: Date;
  /** Name this document file template */
  name: string;
  /** Document fule template type */
  type: DocumentFileTemplateTypeEnum;
  /** User who created this document file template */
  createdBy: UserFindInterface;
  /** File this document file template belongs to */
  file: FileFindInterface;
}

/** Document file template response body - DTO schema */
export const DocumentFileTemplateFindDto = SerdeDtoClass.create<DocumentFileTemplateFindInterface>(CatalogDtosKeysEnum.DOCUMENT_FILE_TEMPLATE_FIND_DTO, {
  id: {
    sortable: true,
    label: 'Глобальный номер',
    hint: 'Уникален в рамках всего ФРМ',
    serializer: yup.number(),
  },
  created: {
    sortable: true,
    label: 'Создан',
    serializer: yup.date(),
  },
  updated: {
    label: 'Изменён',
    serializer: yup.date(),
  },
  deleted: {
    optional: true,
    label: 'Удалён',
    serializer: yup.date(),
  },
  name: {
    sortable: true,
    label: 'Имя',
    serializer: yup.string(),
  },
  createdBy: {
    sortable: true,
    label: 'Пользователь',
    nested: UserFindDto,
    serializer: (_, nested) => nested,
  },
  type: {
    sortable: true,
    label: 'Тип',
    serializer: yup
      .string()
      .oneOf(Object.values(DocumentFileTemplateTypeEnum)),
  },
  file: {
    label: 'Файл шаблона',
    nested: FileFindDto,
    serializer: (_, nested) => nested,
  },
});
